import { ProductParams, TicketI } from './interface';
import { altFind } from '../../class-lib/global-functions';

declare var productData: ProductParams;

/**
 * todo This class has been transformed from .js to .ts some type definitions might be missing
 * ideally jQuery should be replaced with native js functions
 */

export class ProductHandler {

    element = jQuery('#sta_wc_em_integration');
    selectedTicket: TicketI;
    isOnSale: any;
    event_valid: boolean;
    params: ProductParams;

    // elements

    form: any;
    priceDiv: any;
    messages: any;
    ticketSelect: any;
    submit: any;
    quantityOpt: any;
    quantityInput: any;
    cartBtn: any;
    discountCnt: any;
    ticketsLeft: any;
    workshopsCnt: any;
    participantsCnt: any;
    addParticipants: any;

    constructor() {
        this._init_params();
        this._create();
        this._init_digital_product();

        if (this?.params?.tickets) {
            this._init_event_handlers();
        }

        if (this.params.def_participants) {
            this.init_participants(this.params.def_participants);
        }
    }

    _init_params() {
        if (typeof productData !== 'undefined') {
            this.params = productData;
        }

        if (typeof this.params.isOnSale !== 'undefined') {
            this.isOnSale = parseInt(this.params.isOnSale, 10)
        }

        if (typeof this.params.numberOfDecimals !== 'undefined') {
            this.params.numberOfDecimals = Number(this.params.numberOfDecimals)
        }
    }

    _create() {
        this.form = this.element.closest('form');
        this.priceDiv = this.isOnSale ? jQuery('#product-' + this.params.productId + ' .summary ins .woocommerce-Price-amount') : jQuery('#product-' + this.params.productId + ' .summary .woocommerce-Price-amount');
        this.messages = jQuery('.sta-messages');
        this.ticketSelect = jQuery('#sta_event_ticket');
        this.submit = jQuery('.wdm-single-buy-now');
        this.quantityOpt = jQuery('.quantity-options');
        this.quantityInput = jQuery('input[name="quantity"]');
        this.cartBtn = jQuery('.single_add_to_cart_button');
        this.discountCnt = jQuery('.display-discount');
        this.ticketsLeft = jQuery('.tickets-left');
        this.workshopsCnt = this.element.find('.sta-workshops');
        this.participantsCnt = this.element.find('.sta-participants');
        this.addParticipants = this.element.find('.add-participants');
    }

    init_participants(participants: object[]) {
        if (participants && participants.length) {
            for (let k = 0; k < participants.length; k++) {
                let p = participants[k];
                let user = this.createParticipantHtml(k, false, p);
                this.participantsCnt.append(user);
            }
        }
    }

    _init_event_handlers() {
        let self = this;
        this.form.on("submit", jQuery.proxy(this.validate, this));

        this.validateEvent();

        this.updatePrice();

        this.quantityInput.change(() => {
            let quantity = parseInt(this.quantityInput.val());
            let places = Number(this.selectedTicket?.available_spaces);
            this.updateParticipantInputs(quantity);

            if (quantity > places && places !== 0) {
                this.element.find('.message[data-type="qnt"]').remove();
                let message = '<p class="message" data-type="qnt">Achtung! Sie haben mehr Tickets ausgewählt, als Plätze verfügbar sind. Wenn Sie mit der Buchung fortfahren, werden Sie auf die Warteliste gesetzt, bis genügend Plätze verfügbar sind.</p>';
                this.messages.append(message);
                this.messages.show();
            } else {
                this.element.find('.message[data-type="qnt"]').remove();
                if (!this.messages.text()) {
                    this.messages.empty();
                    this.messages.hide();
                }
            }
        })

        this.element.on('change .sta_event_ticket', function () {
            self.updatePrice();
        })

        this.addParticipants.on('click', function (e: any) {
            e.preventDefault();
            e.stopPropagation();
            self.addParticipant();
        })
    }

    _init_digital_product() {
        if (this.params.digital_product) {
            this.quantityOpt.find('.quantity').hide();
        }
    }

    addParticipant(remove = false) {
        let last_participant = this.element.find('.participant').last();
        if (remove) {
            last_participant.remove();
        } else {
            let new_id = last_participant.data('id') + 1;
            let user = this.createParticipantHtml(new_id, true);
            this.participantsCnt.append(user);
        }
    }

    updateParticipantInputs(amount: number) {
        let participants = this.element.find('.participant').length;
        let last_participant = this.element.find('.participant').last();

        if (participants < amount) {
            let new_id = last_participant.data('id') + 1;
            let user = this.createParticipantHtml(new_id);
            this.participantsCnt.append(user);
        } else if (participants > amount && participants > 1) {
            last_participant.remove();
        }
    }

    createOption(name: string, val: string) {
        let opt = document.createElement('option');
        opt.value = val;
        opt.innerText = name;
        return opt;
    }

    createParticipantHtml(i: number, remover: boolean = false, defaults: any = {}) {
        let cnt = document.createElement('div');
        let userData = document.createElement('div');
        userData.classList.add('user-data')
        cnt.setAttribute('data-id', String(i));
        cnt.classList.add('participant');

        let salut = document.createElement('select');
        salut.name = 'participants[' + i + '][salut]';
        salut.appendChild(this.createOption('Anrede', ''))
        salut.appendChild(this.createOption('Herr', 'Herr'))
        salut.appendChild(this.createOption('Frau', 'Frau'))
        userData.appendChild(salut);
        userData.appendChild(this.createEl('span', { html: '&nbsp;' }));

        if (defaults && defaults.salut) {
            salut.value = defaults.salut;
        }

        let name = this.createEl('input', {
            type: 'text',
            placeholder: 'Vorname',
            name: `participants[${i}][given_name]`,
            value: defaults ? defaults.given_name : '',
            required: true
        });
        userData.appendChild(name);
        userData.appendChild(this.createEl('span', { html: '&nbsp;' }));

        let last_name = this.createEl('input', {
            type: 'text',
            placeholder: 'Nachname',
            name: `participants[${i}][family_name]`,
            value: defaults ? defaults.family_name : '',
            required: true
        });
        userData.appendChild(last_name);
        userData.appendChild(this.createEl('span', { html: '&nbsp;' }));

        let email = this.createEl('input', {
            type: 'email',
            placeholder: 'E-Mail',
            name: `participants[${i}][email]`,
            value: defaults ? defaults.email : '',
            required: true
        });
        userData.appendChild(email);

        if (remover) {
            let remove = document.createElement('span');
            remove.innerHTML = '&#10008;';
            remove.className = 'remove';
            remove.title = 'entfernen';
            userData.innerHTML += '&nbsp;';
            remove.addEventListener('click', () => {
                userData.remove();
            })
            userData.appendChild(remove);
        }

        cnt.appendChild(userData);

        if (this.params.workshops) {
            const workshops = this.createWorkshopEl(i);
            cnt.appendChild(workshops);
        }

        if (this.params.product_type === 'special-press') {
            let id = `${i}_press_id`;
            let press = document.createElement('div');
            press.classList.add('special-press');
            let lbl = document.createElement('label');
            lbl.innerText = 'Nummer vom Presseausweis: ';
            lbl.setAttribute('for', id);
            let ID = this.createEl('input', {
                type: 'text',
                placeholder: 'Bitte eingeben',
                id: id,
                required: true,
                name: `participants[${i}][press_id]`,
            });
            press.appendChild(lbl);
            press.appendChild(this.createEl('span', { html: '&nbsp;' }));
            press.appendChild(ID);
            cnt.appendChild(press);
        }

        return cnt;
    }

    createWorkshopEl(i: any) {
        // console.log(this.params);
        let workshops = document.createElement('div');
        workshops.classList.add('workshops');
        for (let k = 0; k < this.params.workshops.length; k++) {

            let ws = this.params.workshops[k];

            let max = parseInt(ws.meta.max_count, 10);
            let free = null;
            let placesText = '';

            if(max) {
                let booked = parseInt(ws.meta.participants_count, 10);
                free = max - booked;
                placesText = ` (Verfügbare Plätze ${free}/${max})`
            }

            // console.log(ws);
            let workshop = document.createElement('div');
            workshop.classList.add('single-workshop')
            let id = 'participant_' + i + '_workshop_' + k;
            let inp = document.createElement('input');
            let lbl = document.createElement('label');
            inp.type = 'checkbox';
            inp.id = id;
            inp.name = 'participants[' + i + '][workshops][]';
            inp.value = ws.term_id.toString(10);

            if (max && free <= 0) {
                inp.disabled = true;
                placesText = ' (ausgebucht)';
            }

            lbl.innerText = ' ' + ws.name + ': ' + ws.description + placesText;
            lbl.setAttribute('for', id);
            workshop.appendChild(inp);
            workshop.innerHTML += '&nbsp;';
            workshop.appendChild(lbl);
            workshops.appendChild(workshop);
        }
        return workshops;
    }

    createEl(tag: string, params: any) {
        let el = document.createElement(tag);

        if (params.id) {
            el.id = params.id;
        }

        if (params.required) {
            (el as HTMLInputElement).required = true;
        }

        if (params.type) {
            (el as HTMLInputElement).type = params.type;
        }

        if (params.value) {
            (el as HTMLInputElement).value = params.value;
        }

        if (params.placeholder) {
            (el as HTMLInputElement).placeholder = params.placeholder;
        }

        if (params.name) {
            (el as HTMLInputElement).name = params.name;
        }

        if (params.html) {
            el.innerHTML = params.html;
        }

        return el;
    }

    validateEvent() {
        if (this?.params?.tickets?.length) {
            this.event_valid = true;
        } else {
            this.event_valid = false;
            this.submit.attr("disabled", true).hide();
            this.cartBtn.attr("disabled", true).hide();
            this.quantityOpt.hide();
            this.ticketSelect.hide();
            this.messages.append('<p>Dieses Produkt ist derzeit leider nicht verfügbar.</p>');
            this.messages.show();
        }
    }

    updateSelectedTicket(ticket: TicketI) {
        this.element.find('[name="sta_selected_ticket_meta[id]"]').val(ticket.ticket_id);
        this.element.find('[name="sta_selected_ticket_meta[event_id]"]').val(ticket.event_id);
        this.element.find('[name="sta_selected_ticket_meta[event_start_time]"]').val(ticket.event_ticket_start_time);
        this.element.find('[name="sta_selected_ticket_meta[event_end_time]"]').val(ticket.event_ticket_end_time);
        this.element.find('[name="sta_selected_ticket_meta[special_event]"]').val(this.params.special_event);
    }

    updatePrice() {
        if (this.event_valid) {
            let price = Number(this.params.product_price);
            let earlyBird = false;

            let selectedTicketEl = this.element.find('.sta_event_ticket option:selected');
            let ticketId = selectedTicketEl.val();

            // IE support
            let ticket = altFind(this.params.tickets, function (ticket: TicketI) {
                return parseInt(ticket.ticket_id) === parseInt(ticketId);
            });

            this.selectedTicket = ticket;

            if (ticket && (ticket.ticket_price || ticket.ticket_price === 0)) {
                price = parseFloat(ticket.ticket_price);
                if (ticket.early_bird_price && ticket.early_bird_valid) {
                    price = parseFloat(ticket.early_bird_price);
                    earlyBird = true;
                    this.renderEarlyBirdPrice(ticket.ticket_price, ticket.early_bird_price);
                } else {
                    this.renderEarlyBirdPrice(ticket.ticket_price, ticket.ticket_price, false);
                }
                this.updateSelectedTicket(ticket);
            }
            if (ticket) {
                this.ticketsLeft.empty();
                this.ticketsLeft.removeClass('none');
                if (ticket.available_spaces > 0 && ticket.available_spaces <= 10) {
                    this.ticketsLeft.append('<p class="available">nur noch ' + ticket.available_spaces + ' Ticket(s) übrig</p>')
                } else if (ticket.available_spaces === 0) {
                    this.ticketsLeft.append('<p class="not-available">Alle Tickets sind ausverkauft!</p>')
                }
            }

            // console.log(ticket);
            // console.log(this);

            this.validateSpaces(ticket);
            let separator = this.params.decimalSeparator || ',';
            let formattedPrice = price.toFixed(this.params.numberOfDecimals).replace('.', separator);

            formattedPrice = this.addThousandSeparator(formattedPrice);
            if (this.priceDiv.find('bdi').contents().first()[0]) {
                this.priceDiv.find('bdi').contents().first()[0].textContent = formattedPrice
            } else {
                this.priceDiv.contents().first()[0].textContent = formattedPrice;
            }

            if (earlyBird) {
                this.priceDiv.addClass('early-bird');
            } else {
                this.priceDiv.removeClass('early-bird');
            }
        }
    }

    renderEarlyBirdPrice(regular: any, discount: any, show = true) {
        regular = this.formatPrice(parseInt(regular));
        discount = this.formatPrice(parseInt(discount));
        let html = '<input disabled="disabled" type="radio" id="regular" name="display_price" value="regular">\n' +
            '<label class="no-touch" for="regular">Standard-Preis: ' + regular + '</label>\n' +
            '<input checked="checked" type="radio" id="discount" name="display_price" value="discount">\n' +
            '<label for="discount">Frühbucherpreis: ' + discount + '</label>';

        if (this.discountCnt) {
            if (show) {
                this.discountCnt.empty();
                this.discountCnt.append(html);
                this.discountCnt.show();
            } else {
                this.discountCnt.hide();
            }
        }

    }

    validateSpaces(ticket: any) {
        if (parseInt(ticket.available_spaces) === 0) {
            let message = '<p class="message" data-type="spaces">Achtung! Dieser Termin is bereits ausverkauft. Sie können mit der Buchung fortfahren und werden auf die Warteliste aufgenommen.</p>';
            this.messages.empty();
            this.messages.append(message);
            this.messages.show();
        } else {
            this.element.find('.message[data-type="spaces"]').remove();
            if (!this.messages.text()) {
                this.messages.hide();
            }
        }
    }

    validateInputs() {
        const invalidFields = this.form.querySelectorAll('input:invalid') as NodeList;
        const requiredFields = this.form.querySelectorAll('input:required') as NodeList;

        if(requiredFields.length === 0) {
            return true;
        }
        Array.from(requiredFields, (input: HTMLInputElement) => {
            if(input.checkValidity()) {
                input.classList.remove('invalid');
            } else {
                input.classList.add('invalid');
            }
        })
    }

    validateWorkshops(rsp: boolean = false) {
        let valid = false; //todo
        if (this.participantsCnt && this.params.workshops_meta) {
            let min = this.params.workshops_meta.min ? parseInt(this.params.workshops_meta.min) : 0;
            let max = this.params.workshops_meta.max ? parseInt(this.params.workshops_meta.max) : 0;
            let msgCnt = this.element.find('.workshop-msg');
            msgCnt.empty();

            let participants = this.participantsCnt.find('.participant');

            if (participants) {
                participants.each((i: number, p: any) => {
                    let participant = jQuery(p);
                    let workshops = participant.find('.workshops');
                    let checked = workshops.find('input:checked').length;

                    valid = false;
                    if ((min && (checked < min))) {
                        msgCnt.show();
                        msgCnt.append('<p>Bitte wählen Sie mindestens ' + min + ' Workshops aus.</p>');
                        valid = false;
                        workshops.addClass('error');
                    } else if ((max && (checked > max))) {
                        msgCnt.show();
                        msgCnt.append('<p>Sie haben zu viele Workshops gewählt, die Begrenzung ist ' + max + '.</p>');
                        valid = false;
                        workshops.addClass('error');
                    } else {
                        msgCnt.hide();
                        valid = true;
                        workshops.removeClass('error');
                    }

                    if (!valid) {
                        return false;
                    }
                });
            }

        }
        if (rsp) {
            return valid;
        }
    }

    validateWorkshopSlots() {
        let valid = true;
        let msgCnt = this.element.find('.workshop-msg');
        msgCnt.empty();
        for (let k = 0; k < this.params.workshops.length; k++) {
            let ws = this.params.workshops[k];
            // console.log(ws);
            let max = parseInt(ws.meta.max_count, 10);
            let booked = parseInt(ws.meta.participants_count, 10);
            let free = max - booked;

            let checked = document.querySelectorAll(`.workshops input:checked[value="${ws.term_id}"]`).length;

            if (checked && free < checked) {
                msgCnt.append('<p>Sie haben mehr Workshops (' + ws.name + ') ausgewählt als Plätze zur Verfügung stehen (' + free + ').</p>');
                msgCnt.show();
                valid = false;
                console.error('Not enough workshop spaces');
                break;
            }
        }
        return valid;
    }


    validate() {
        let formValid = true;

        let selector = this.element.find('.sta_event_ticket');
        let event_date = this.element.find('[name="sta_selected_ticket_meta[event_start_time]"]').val();
        let id = this.element.find('[name="sta_selected_ticket_meta[id]"]').val();

        if (!event_date || !id) {
            formValid = false;
            console.log('invalid-ticket')
            this.element.find('.message[data-type="invalid-ticket"]').remove();
            let message = '<p class="message" data-type="invalid-ticket">Dieses Ticket ist derzeit nicht verfügbar. Bitte kontaktieren Sie den Support für weitere Informationen.</p>';
            this.messages.append(message);
            this.messages.show();
            selector.focus();
        } else {
            this.element.find('.message[data-type="invalid-ticket"]').remove();
            if (!this.messages.text()) {
                this.messages.hide();
            }
        }

        if (formValid && this.workshopsCnt && this.params.workshops_meta && (this?.params?.workshops.length)) {
            formValid = this.validateWorkshops(true);

            if (formValid) {
                formValid = this.validateWorkshopSlots();
            }
        }

        if (!formValid) {
            console.error('Form invalid');
        }
        return formValid;
    }

    formatPrice(price: string | number) {
        let separator = this.params.decimalSeparator || ',';
        let formattedPrice = Number(price).toFixed(this.params.numberOfDecimals).replace('.', separator);
        formattedPrice = this.addThousandSeparator(formattedPrice) + '€';
        return formattedPrice;
    }


    addThousandSeparator(nStr: any) {
        if (this.params.thousandSeparator === '') {
            return nStr;
        }
        nStr += '';
        let x = nStr.split('.');
        let x1 = x[0];
        let x2 = x.length > 1 ? '.' + x[1] : '';
        let rgx = /(\d+)(\d{3})/;
        while (rgx.test(x1)) {
            x1 = x1.replace(rgx, '$1' + this.params.thousandSeparator + '$2');
        }
        return x1 + x2;
    }

}
